'use strict';

module.exports = require('openchemlib-extended/lib/extend')(require('openchemlib/minimal'));



//////////////////
// WEBPACK FOOTER
// ./~/openchemlib-extended-minimal/index.js
// module id = 41
// module chunks = 0